import React, { useEffect, useState } from "react";
import axios from "axios";
import LoadingInd from "../components/LoadingInd";
import Image from "react-graceful-image";

const UserImg = ({ ids }) => {
  const [img, setImg] = useState([]);
  const [isLoadin, setLoadin] = useState(true);

  useEffect(() => {
    axios
      .get(
        "https://insta.nextacademy.com/api/v2/images?userId=" + ids
        // "https://aqueous-plains-06808.herokuapp.com/api/v1/users/images/all/" +
        // ids
      )
      .then((res) => {
        setLoadin(false);
        setImg(res.data);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return isLoadin ? (
    <LoadingInd w={30} h={30} />
  ) : (
    img.map((o, index) => (
      <div key={index}>
        <Image
          style={{ width: "100px", height: "100px" }}
          src={o.url}
          alt="no image"
        />
      </div>
    ))
  );
};

export default UserImg;
